import { Component, computed, effect, input, output, signal, untracked } from '@angular/core';
import { Policy } from 'api-clients/ai-api-client';
import { PolicyCard } from 'src/shared/ez-card/ez-selectable-card/policy-card/policy-card';
import { PolicyCardComponent } from 'src/shared/ez-card/ez-selectable-card/policy-card/policy-card.component';

@Component({
  selector: 'ez-eva-policies',
  imports: [
    PolicyCardComponent,
  ],
  templateUrl: './eva-policies.component.html',
  styleUrl: './eva-policies.component.scss',
})
export class EvaPoliciesComponent {
  protected readonly policies = input.required<Policy[]>();
  protected readonly policyId = input<number | null>(null);
  protected readonly isHistoryLoaded = input<boolean>(false);
  protected readonly selectedPolicy = output<Policy>();

  readonly #selectedPolicy = signal<Policy | null>(null);
  protected readonly hasSelection = computed(() => this.#selectedPolicy() != null);
  protected readonly isSelectionDisabled = computed(() => this.isHistoryLoaded() && this.policyId() != null);

  protected readonly policySelectionStates = computed(() => {
    const selected = this.#selectedPolicy();
    const hasSelection = selected != null;

    return this.policies().map(policy =>
      !hasSelection ? false : policy.policyMasterID === selected?.policyMasterID ? true : undefined
    );
  });

  protected readonly cardPolicies = computed((): PolicyCard[] =>
    this.policies().map((policy): PolicyCard => ({
      policyMasterID: policy.policyMasterID,
      policyDetailID: policy.policyDetailID,
      applicantId: policy.applicantId,
      policyNumber: policy.policyNumber ?? '',
      lob: policy.lob ?? '',
      carrierName: policy.carrierName ?? '',
      effectiveDate: policy.effectiveDate,
      expirationDate: policy.expirationDate,
      policyStatus: policy.policyStatus ?? '',
    }))
  );

  constructor() {
    effect(() => {
      const policyIdToSelect = this.policyId();
      if (policyIdToSelect != null) {
        const policy = untracked(() => this.policies().find(p => p.policyMasterID === policyIdToSelect));
        if (policy && untracked(() => this.#selectedPolicy())?.policyMasterID !== policyIdToSelect) {
          this.#selectedPolicy.set(policy);
        }
      }
    });
  }

  protected onPolicySelect(policyMasterID: number, selected: boolean): void {
    if (this.isSelectionDisabled() || this.hasSelection()) {
      return;
    }

    if (selected) {
      const policy = this.policies().find(p => p.policyMasterID === policyMasterID);
      if (policy) {
        this.#selectedPolicy.set(policy);
        this.selectedPolicy.emit(policy);
      }
    }
  }
}
